import styled from 'styled-components';

export const StyledWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--white);
`;

export const StyledDropdownWrapper = styled.div<{ maxHeight?: number }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: var(--white);
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: ${props => props.maxHeight ? `${props.maxHeight}px` : 'calc(7 * 48px)'};
  overflow-y: auto;
`;

export const StyledScrollableContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledEmptyState = styled.div`
  padding: 12px 16px;
  color: var(--textGrey);
  font-size: 14px;
`;